"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * Helper hook to save the previous value of a variable in a ref.
 */
function usePrevious(value) {
    var ref = react_1.useRef();
    react_1.useEffect(function () {
        ref.current = value;
    }, [value]);
    return ref.current;
}
exports.usePrevious = usePrevious;
/**
 *  Helper hook, using usePrevious, that returns true if a value
 *  has changed, and false otherwise.
 *
 */
function useHasChanged(value) {
    var oldValue = usePrevious(value);
    var hasChanged = oldValue !== undefined && oldValue !== value;
    return hasChanged;
}
exports.useHasChanged = useHasChanged;
